import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import DialogModal from '../utils/DialogModal';


export interface DeviceErrorDialogProps {
  open: boolean;
  onClose: (value?: string) => void;
}

const DeviceErrorDialog = (props: DeviceErrorDialogProps) => {

  const liveStreamRunning = useSelector((state: any) => state.layout.liveStreamRunning);

  const { open, onClose, ...other } = props;

  return (
    <DialogModal large={true} open={open} hasCloseAction={true} onClose={onClose} iconClass={"exclam"} buttonCancel={"CANCEL"} buttonOk={"RESELECT DEVICES"}>
      <>
        <div><p>Can&apos;t access Camera and Microphone</p>
        <br/><br/>
        Please close all other apps using Camera or Microphone and reload this page.
        <br/><br/>
        </div>
      </>
    </DialogModal>
  )
}

export default DeviceErrorDialog;

